import React from "react";

const WideSpreadInput = (props) => {
  const {
    type,
    label,
    hideLabel,
    value,
    name,
    onChange,
    disabled,
    required,
    placeholder,
  } = props;

  return (
    <div className="flex">
      <div className="flex w-1/3 items-center">
        <label htmlFor={name} className={hideLabel ? "sr-only" : "text-xs"}>
          {label}
        </label>
      </div>
      <div className="w-1/2 ml-5 text-xs justify-self-center">
        <input
          id={name}
          type={type}
          value={value ?? ""}
          name={name}
          onChange={onChange}
          disabled={disabled}
          required={required}
          placeholder={placeholder}
          className="w-full justify-self-center min-w-min h-8 px-1 border rounded-md"
        />
      </div>
    </div>
  );
};

export default WideSpreadInput;
